module.exports = __webpack_public_path__ + "3e582422cdd1469ffb458f37efc010ac.gif";